/* ============================================================
   Running PDP (product.running-v2) controller
   Self-contained. One instance per .running-pdp[data-rp-root].
   ============================================================ */
(function () {
  'use strict';


  function applyWorkspaceMedia(data) {
    var ws = data.workspaceData;
    if (!ws || ws.schema !== 1 || !Array.isArray(ws.media) || !Array.isArray(ws.palette)) return;
    var rows = ws.media.slice().sort(function (a, b) { return a.order - b.order; });
    var firstGallery = [];
    ws.palette.forEach(function (p) {
      var own = rows.filter(function (m) { return m.color === p.id && m.role === 'pdp' && m.type === 'image'; });
      if (!firstGallery.length && own.length) firstGallery = own;
    });
    ws.palette.forEach(function (p) {
      var c = data.colors[p.name] || (data.colors[p.name] = { group: p.group });
      var own = rows.filter(function (m) { return m.color === p.id; });
      function role(name) { return own.filter(function (m) { return m.role === name; }); }
      var gallery = role('pdp').filter(function (m) { return m.type === 'image'; });
      if (!gallery.length) gallery = firstGallery;
      c.pdp = gallery.map(function (m) { return m.src; });
      c.front = c.pdp[0] || null; c.back = c.pdp[1] || null;
      c.look = role('men'); c.lookW = role('women');
      c.motion = role('motion_men'); c.motionW = role('motion_women');
      c.details = role('details').map(function (m) { return m.src; });
      c.model = p.model; c.modelW = p.modelW;
      var card = rows.find(function (m) { return m.id === p.mockup; });
      c.card = card ? card.src : c.front;
    });
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function slideMetrics(track) {
    var slide = track.querySelector(':scope > *');
    var w = slide ? slide.getBoundingClientRect().width : track.clientWidth;
    var styles = getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return { step: w + gap, count: track.children.length };
  }

  // Slider with an OPTIONAL infinite loop (used for the top mockups and the detail images).
  // When there is >1 slide we clone slides onto BOTH ends and, once the scroll settles on a
  // clone, jump instantly by exactly realCount slides, so scrolling wraps around seamlessly.
  //
  // The number of clones per side is NOT fixed at 1: on desktop the details slider shows more
  // than one slide at a time, so the last reachable scroll position (maxScroll) never lands on
  // a single trailing clone — the wrap simply never fired and the slider dead-ended on the last
  // image. Cloning ceil(clientWidth / step) slides per side guarantees the clone zone is always
  // reachable, on any viewport. Recomputed on resize.
  function bindSlider(sliderEl, startIndex, onIndex) {
    var track = sliderEl.querySelector('[data-rp-track]');
    if (!track) return;
    var prev = sliderEl.querySelector('[data-rp-prev]');
    var next = sliderEl.querySelector('[data-rp-next]');
    var bars = sliderEl.querySelectorAll('.rp-progress__bar');
    var reals = Array.prototype.slice.call(track.children);
    var realCount = reals.length;
    var loop = realCount > 1;
    var cloneN = 0;

    function step() {
      var slide = track.querySelector(':scope > *');
      var w = slide ? slide.getBoundingClientRect().width : track.clientWidth;
      var s = getComputedStyle(track);
      var gap = parseFloat(s.columnGap || s.gap || '0') || 0;
      return w + gap;
    }
    function jumpTo(px) {
      var sb = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto'; track.scrollLeft = px; track.style.scrollBehavior = sb;
    }
    function rawIdx() { var s = step(); return s ? Math.round(track.scrollLeft / s) : 0; }
    function realIdx() {
      if (!loop) return rawIdx();
      return ((rawIdx() - cloneN) % realCount + realCount) % realCount;
    }

    function buildClones(keepReal) {
      if (!loop) return;
      Array.prototype.slice.call(track.querySelectorAll('[data-rp-clone]')).forEach(function (n) { n.remove(); });
      cloneN = 0;
      var s = step();
      var need = s ? Math.ceil(track.clientWidth / s) : 1;
      if (!isFinite(need) || need < 1) need = 1;
      if (need > realCount) need = realCount;
      for (var i = 0; i < need; i++) {
        var head = reals[realCount - 1 - i].cloneNode(true);
        head.setAttribute('data-rp-clone', ''); head.setAttribute('aria-hidden', 'true');
        track.insertBefore(head, track.firstChild);
        var tail = reals[i].cloneNode(true);
        tail.setAttribute('data-rp-clone', ''); tail.setAttribute('aria-hidden', 'true');
        track.appendChild(tail);
      }
      cloneN = need;
      jumpTo((cloneN + (keepReal || 0)) * step());
    }

    function paintBars() {
      var i = realIdx();
      bars.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
      if (typeof onIndex === 'function') onIndex(i);
      if (!loop) { if (prev) prev.disabled = rawIdx() <= 0; if (next) next.disabled = rawIdx() >= track.children.length - 1; }
    }
    function slideSmooth(rawTarget) { track.scrollTo({ left: Math.max(0, rawTarget) * step(), behavior: 'smooth' }); }

    var startAt = parseInt(startIndex, 10); if (!(startAt >= 0)) startAt = 0;
    if (startAt > realCount - 1) startAt = realCount - 1;
    buildClones(startAt);

    if (prev) prev.addEventListener('click', function () { slideSmooth(rawIdx() - 1); });
    if (next) next.addEventListener('click', function () { slideSmooth(rawIdx() + 1); });
    bars.forEach(function (b, i) { b.style.cursor = 'pointer'; b.addEventListener('click', function () { slideSmooth(loop ? cloneN + i : i); }); });

    var settle;
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(paintBars);
      if (!loop) return;
      clearTimeout(settle);
      settle = setTimeout(function () {
        var raw = rawIdx();
        if (raw < cloneN) { jumpTo((raw + realCount) * step()); }              // in the leading clone zone
        else if (raw >= cloneN + realCount) { jumpTo((raw - realCount) * step()); } // in the trailing clone zone
        paintBars();
      }, 90);
    }, { passive: true });

    if (loop && typeof ResizeObserver === 'function') {
      var lastW = track.clientWidth, rt;
      new ResizeObserver(function () {
        if (track.clientWidth === lastW) return;
        lastW = track.clientWidth;
        clearTimeout(rt);
        rt = setTimeout(function () { var cur = realIdx(); buildClones(cur); paintBars(); }, 150);
      }).observe(track);
    }

    paintBars();
  }

  /* ---------- Theme cart drawer suppression ----------
     Adding from Shop the Look must NEVER open the theme cart drawer. Dispatching
     'cart:build' instead of 'ajaxProduct:added' fixed that on mobile, but on desktop
     the drawer still popped up – i.e. something outside Impulse's own CartDrawer
     (an app script reacting to /cart/add.js) opens it. Instead of guessing the culprit
     we block the drawer itself for a short window after a silent add:
       1. <html> gets .rp-cartdrawer-off, which hides #CartDrawer via CSS -> no flash,
          no matter who opens it or how.
       2. Impulse fires 'drawerOpen.CartDrawer' on open -> we close it properly
          (via 'cart:close', so focus trap + scroll lock are released).
       3. A MutationObserver catches openers that bypass Impulse and set the classes
          directly.
     The window is short (2.5 s) so a real click on the cart icon still works. */
  var rpBlockUntil = 0, rpBlockTimer = null, rpBlockObs = null;

  function rpCartDrawerIsOpen() {
    var d = document.getElementById('CartDrawer');
    return !!(document.documentElement.classList.contains('js-drawer-open') &&
      d && d.classList.contains('drawer--is-open'));
  }

  function rpForceCloseCartDrawer() {
    try { document.dispatchEvent(new CustomEvent('cart:close')); } catch (e) {}
    // Fallback for openers that never went through Impulse's Drawers instance.
    setTimeout(function () {
      if (!rpCartDrawerIsOpen()) return;
      var d = document.getElementById('CartDrawer');
      if (d) d.classList.remove('drawer--is-open');
      document.documentElement.classList.remove('js-drawer-open');
    }, 60);
  }

  function suppressThemeCartDrawer(ms) {
    ms = ms || 2500;
    rpBlockUntil = Date.now() + ms;
    document.documentElement.classList.add('rp-cartdrawer-off');
    if (rpCartDrawerIsOpen()) rpForceCloseCartDrawer();
    if (!rpBlockObs) {
      rpBlockObs = new MutationObserver(function () {
        if (Date.now() < rpBlockUntil && rpCartDrawerIsOpen()) rpForceCloseCartDrawer();
      });
      rpBlockObs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      var cd = document.getElementById('CartDrawer');
      if (cd) rpBlockObs.observe(cd, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('drawerOpen.CartDrawer', function () {
        if (Date.now() < rpBlockUntil) rpForceCloseCartDrawer();
      });
      document.addEventListener('drawerOpen', function () {
        if (Date.now() < rpBlockUntil && rpCartDrawerIsOpen()) rpForceCloseCartDrawer();
      });
    }
    clearTimeout(rpBlockTimer);
    rpBlockTimer = setTimeout(function () {
      rpBlockUntil = 0;
      document.documentElement.classList.remove('rp-cartdrawer-off');
    }, ms);
  }

  /* Quellenwahl fuers Video.
     Shopify transkodiert nur bis 1080p auf der LANGEN Kante. Bei Hochformat 2:3 sind das
     720 px Breite – ein iPhone rendert die Kachel aber mit ueber 1100 physischen Pixeln,
     also wird hochskaliert und sichtbar unscharf. Der adaptive HLS-Stream ist noch
     schlechter: die unterste Stufe hat 320 px und Safari bleibt bei kleinen Elementen
     gern darauf haengen. Deshalb hat die unveraenderte Originaldatei Vorrang (kommt als
     m.orig aus dem Liquid, gleiche Aufloesung wie hochgeladen), danach die passende
     Rendition. Kein HLS mehr – die .m3u8 darf nie in ein <video src> landen.
     Zurueckgegeben wird eine Kandidatenliste; bei einem Ladefehler schaltet das Element
     selbsttaetig auf den naechsten Eintrag weiter. */
  function videoCandidates(m) {
    var list = (m && m.sources) || [];
    var mp4 = [];
    for (var i = 0; i < list.length; i++) {
      var s = list[i];
      if (!s || !s.url) continue;
      if (s.format ? s.format === 'm3u8' : /\.m3u8(\?|$)/.test(s.url)) continue;
      if (s.format ? s.format === 'mp4' : /\.mp4(\?|$)/.test(s.url)) mp4.push(s);
    }
    var vw = window.innerWidth || 1024;
    var tile = vw > 900 ? Math.round(vw / 3) : vw;
    var want = tile * (window.devicePixelRatio || 1);
    var best = null, largest = null;
    for (var j = 0; j < mp4.length; j++) {
      var t = mp4[j];
      if (!largest || (t.width || 0) > (largest.width || 0)) largest = t;
      if ((t.width || 0) >= want && (!best || (t.width || 0) < (best.width || 0))) best = t;
    }
    var out = [];
    function add(u) { if (u && out.indexOf(u) < 0) out.push(u); }
    add(m && m.orig);
    add(best && best.url);
    add(largest && largest.url);
    add(m && m.src);
    return out;
  }

  function pickVideoSource(m) {
    var c = videoCandidates(m);
    return c[0] || '';
  }

  /* Autoplay auf iOS ist zickiger als auf allen anderen Plattformen:
     - WebKit wertet fuer die Autoplay-Entscheidung die muted-PROPERTY aus. Wird das Element
       wie hier per innerHTML gebaut, reicht das muted-ATTRIBUT nicht zuverlaessig – muted /
       defaultMuted / playsInline muessen nach dem Einhaengen noch einmal per JS gesetzt werden.
     - play() muss ausserdem erneut versucht werden, sobald wirklich Daten da sind
       (loadeddata/canplay), weil preload="none" + spaet gesetzte src beim ersten Versuch
       oft noch nichts zu dekodieren hat.
     - Im Stromsparmodus verweigert iOS Autoplay komplett. Dann wird ein einmaliger
       touchstart/click-Listener scharf gestellt: die naechste Beruehrung (auch der Beginn
       einer Wischgeste) gilt als User-Geste und startet das Video nach – ohne dass der
       Kunde etwas anklicken muss.
     Die Datei haengt weiterhin erst am Element, wenn die Kachel in den Viewport kommt. */
  var rpGestureArmed = false, rpPendingVideos = [];

  function rpArmGesture(v) {
    if (rpPendingVideos.indexOf(v) < 0) rpPendingVideos.push(v);
    if (rpGestureArmed) return;
    rpGestureArmed = true;
    var fire = function () {
      rpPendingVideos.forEach(function (el) {
        rpPrimeVideo(el);
        try { var p = el.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      });
      rpPendingVideos = [];
      rpGestureArmed = false;
      document.removeEventListener('touchstart', fire, true);
      document.removeEventListener('click', fire, true);
    };
    document.addEventListener('touchstart', fire, true);
    document.addEventListener('click', fire, true);
  }

  function rpPrimeVideo(v) {
    try {
      v.muted = true;
      v.defaultMuted = true;
      v.volume = 0;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
    } catch (e) {}
  }

  function rpPlayVideo(v) {
    rpPrimeVideo(v);
    var p;
    try { p = v.play(); } catch (e) { rpArmGesture(v); return; }
    if (p && p.then) {
      p.catch(function () {
        if (v.readyState < 2) {
          var again = function () {
            v.removeEventListener('loadeddata', again);
            v.removeEventListener('canplay', again);
            rpPrimeVideo(v);
            try { var q = v.play(); if (q && q.catch) q.catch(function () { rpArmGesture(v); }); }
            catch (e) { rpArmGesture(v); }
          };
          v.addEventListener('loadeddata', again);
          v.addEventListener('canplay', again);
        }
        rpArmGesture(v);
      });
    }
  }

  function observeVideos(scope) {
    var vids = scope.querySelectorAll('video[data-rp-video]');
    if (!vids.length) return;
    function load(v) {
      rpPrimeVideo(v);
      var src = v.getAttribute('data-rp-src');
      if (src && !v.getAttribute('src')) {
        v.setAttribute('preload', 'auto');
        v.setAttribute('src', src);
        v.load && v.load();
      }
    }
    /* Die Originaldatei liegt unter einer abgeleiteten CDN-URL. Falls die fuer eine
       Datei mal nicht ausgeliefert wird (fehlender oder falscher Content-Type, alter
       Upload), faellt das Element auf die naechste Rendition zurueck statt schwarz
       zu bleiben. */
    function fallback(v) {
      var rest = (v.getAttribute('data-rp-alt') || '').split('|').filter(Boolean);
      if (!rest.length) return;
      var next = rest.shift();
      v.setAttribute('data-rp-alt', rest.join('|'));
      v.setAttribute('src', next);
      v.load && v.load();
      rpPlayVideo(v);
    }
    vids.forEach(function (v) {
      rpPrimeVideo(v);
      v.addEventListener('loadeddata', function () { if (v.paused) rpPlayVideo(v); });
      v.addEventListener('error', function () { fallback(v); });
    });
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { load(v); rpPlayVideo(v); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { load(v); rpPlayVideo(v); }
        else { v.pause && v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-rp-acc]').forEach(function (acc) {
      var head = acc.querySelector('[data-rp-acc-head]');
      var body = acc.querySelector('[data-rp-acc-body]');
      if (!head || !body) return;
      head.addEventListener('click', function () {
        var open = acc.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          body.style.height = body.scrollHeight + 'px';
          var done = function () { body.style.height = 'auto'; body.removeEventListener('transitionend', done); };
          body.addEventListener('transitionend', done);
        } else {
          body.style.height = body.scrollHeight + 'px';
          void body.offsetHeight;
          body.style.height = '0px';
        }
      });
    });
  }

  function initPDP(root) {
    var dataEl = root.querySelector('[data-rp-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    applyWorkspaceMedia(data);

    var state = { color: data.initialColor, size: data.initialSize };
    var labels = data.labels || { add: 'Add to cart', notify: 'Notify me' };

    var swatches = root.querySelectorAll('[data-rp-swatch]');
    var sizeBtns = root.querySelectorAll('[data-rp-size]');
    var priceEl = root.querySelector('[data-rp-price]');
    var compareEl = root.querySelector('[data-rp-compare]');
    var atcBtn = root.querySelector('[data-rp-atc]');
    var notifyBtn = root.querySelector('[data-rp-notify]');
    var formHolder = root.querySelector('[data-rp-form-holder]');
    var nativeSelect = formHolder ? formHolder.querySelector('[data-product-select]') : null;
    var realAtc = formHolder ? formHolder.querySelector('[data-add-to-cart]') : null;
    var colorLabels = root.querySelectorAll('[data-rp-current-color]');
    var mockupSlider = root.querySelector('[data-rp-mockups]');

    // dynamic section containers
    var stlSec = root.querySelector('[data-rp-stl]');
    var detailsSec = root.querySelector('[data-rp-details]');
    var moreTrack = root.querySelector('[data-rp-more-track]');
    var moreSec = root.querySelector('.rp-more');
    var outfitSec = root.querySelector('[data-rp-outfit]');
    var drawer = root.querySelector('[data-rp-drawer]');
    var drawerBody = root.querySelector('[data-rp-drawer-body]');

    function findVariant(color, size) {
      var list = data.variants || [];
      var hit = list.filter(function (v) { return v.color === color && v.size === size; })[0];
      if (hit) return hit;
      if (data.hasColorOption !== true || color === null || color === undefined) {
        hit = list.filter(function (v) { return v.size === size; })[0];
        if (hit) return hit;
      }
      return null;
    }
    function isPreorderVariant(v) {
      if (!data.isPreorderProduct) return false;
      if (!v) return false;
      return (typeof v.qty === 'number') && v.qty <= 0 && v.policy === 'continue';
    }
    function atcLabelFor(v) {
      return isPreorderVariant(v) ? (labels.preorder || labels.add) : labels.add;
    }
    function preorderProps(v) {
      if (!isPreorderVariant(v) || !data.shipProp) return null;
      var props = { '_preorder': '1' };
      props[data.shipPropKey || 'Shipping'] = data.shipProp;
      return props;
    }
    /* Shop the Look shows FOREIGN products: never gate those on this page's
       preorder flag or ship date, always on the item's own fields. */
    function isPreorderLook(item, size) {
      if (!item || !item.isPreorderProduct) return false;
      if (!size) return false;
      return (typeof size.qty === 'number') && size.qty <= 0 && size.policy === 'continue';
    }
    function lookLabelFor(item, size) {
      return isPreorderLook(item, size) ? (labels.preorder || labels.add) : labels.add;
    }
    function lookPropsFor(item, size) {
      if (!isPreorderLook(item, size) || !item.shipProp) return null;
      var props = { '_preorder': '1' };
      props[data.shipPropKey || 'Shipping'] = item.shipProp;
      return props;
    }
    function firstAvailableSize(color) {
      var list = data.variants || [];
      var anyColor = (data.hasColorOption !== true || color === null || color === undefined);
      var av = list.filter(function (v) { return (anyColor || v.color === color) && v.available; })[0];
      return av ? av.size : (list.filter(function (v) { return anyColor || v.color === color; })[0] || {}).size;
    }

    /* ---------- upper area: top mockup gallery (always the up-to-4 images) ----------
       The top PDP gallery is NOT part of the Static/Motion feature — it stays images
       only. bindSlider is rebuilt at the first slide on a breakpoint change (bugfix:
       the loop slider used to keep its index across the width jump). */
    var RP_ARROWS =
      '<button type="button" class="rp-slider__arrow rp-slider__arrow--prev" data-rp-prev aria-label="Previous"><svg viewBox="0 0 24 24" fill="none"><path d="M15 4l-8 8 8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" class="rp-slider__arrow rp-slider__arrow--next" data-rp-next aria-label="Next"><svg viewBox="0 0 24 24" fill="none"><path d="M9 4l8 8-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

    function renderMockups(color) {
      if (!mockupSlider) return;
      var c = data.colors[color] || {};
      var imgs = (c.pdp && c.pdp.length) ? c.pdp.slice() : [];
      if (!imgs.length) { if (c.front) imgs.push(c.front); if (c.back) imgs.push(c.back); }
      if (!imgs.length) { mockupSlider.innerHTML = ''; mockupSlider.classList.add('rp-hidden'); return; }
      mockupSlider.classList.remove('rp-hidden');
      mockupSlider.innerHTML =
        RP_ARROWS +
        '<div class="rp-slider__track" data-rp-track>' +
          imgs.map(function (src, i) {
            return '<div class="rp-slider__slide"><div class="rp-mockup"><img src="' + esc(src) + '" alt="' + esc(data.title + ' – ' + color + ' – ' + (i + 1)) + '" ' + (i < 2 ? 'loading="eager"' + (i === 0 ? ' fetchpriority="high"' : '') : 'loading="lazy"') + '></div></div>';
          }).join('') +
        '</div>' +
        (imgs.length > 1 ? '<div class="rp-progress">' + imgs.map(function (_, i) { return '<span class="rp-progress__bar' + (i === 0 ? ' is-active' : '') + '"></span>'; }).join('') + '</div>' : '');
      bindSlider(mockupSlider, 0);
    }

    /* ---------- Shop the Look: Static (portraits) / Motion (video) ----------
       The toggle lives in the STL footer (desktop: left of the CTA; mobile: between the
       progress dashes and the CTA). Static shows the shop_the_look_media portraits.
       Motion swaps them for the colour's pdp_motion_media video(s) in the SAME grid —
       a single video sits where the first portrait was with nothing beside it, several
       videos line up like the images. The top PDP gallery is never touched. */
    var motionToggle = root.querySelector('[data-rp-motion-toggle]');
    /* Men/Women: gender = 'm' | 'w'. Women data comes from the *_w fields of the
       colour entry (lookW / motionW / modelW in the JSON). No women data -> no toggle,
       gender is forced back to 'm'. Women + Motion without an own women video falls
       back to the general (men) video. */
    var genderToggle = root.querySelector('[data-rp-gender-toggle]');
    var stlState = { mode: 'static', gender: 'm' };
    function motionList(color, gender) {
      var c = data.colors[color] || {};
      var list = (gender === 'w' && (c.motionW || []).length) ? c.motionW : (c.motion || []);
      return list.filter(function (m) { return m && m.type === 'video'; });
    }
    function lookList(color, gender) {
      var c = data.colors[color] || {};
      return (gender === 'w' && (c.lookW || []).length) ? c.lookW : (c.look || []);
    }
    function hasWomen(color) {
      var c = data.colors[color] || {};
      return (c.lookW || []).length > 0 || (c.motionW || []).length > 0;
    }
    function updateGenderButtons() {
      if (!genderToggle) return;
      genderToggle.querySelectorAll('[data-rp-gender]').forEach(function (b) {
        var on = b.getAttribute('data-rp-gender') === stlState.gender;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    /* Desktop: the gender toggle sits in the STL head, right of the heading. Mobile:
       vertical overlay on top of the look media (top-left). One element, moved. */
    function placeGenderToggle() {
      if (!genderToggle || !stlSec) return;
      var head = stlSec.querySelector('.rp-stl__head');
      var mediaEl = stlSec.querySelector('[data-rp-stl-media]');
      if (window.innerWidth > 900) {
        if (head && genderToggle.parentNode !== head) head.appendChild(genderToggle);
      } else if (mediaEl && genderToggle.parentNode !== mediaEl) {
        mediaEl.appendChild(genderToggle);
      }
    }
    function updateMotionButtons() {
      if (!motionToggle) return;
      motionToggle.querySelectorAll('[data-rp-motion]').forEach(function (b) {
        var on = b.getAttribute('data-rp-motion') === stlState.mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    /* Desktop: toggle in the STL footer, left of the CTA. Mobile: directly under the
       STL heading (segmented, left-aligned — see CSS). Only the position differs; the
       markup is one element that we move. */
    function placeMotionToggle() {
      if (!motionToggle || !stlSec) return;
      var foot = stlSec.querySelector('.rp-stl__foot');
      var heading = stlSec.querySelector('[data-rp-stl-heading]');
      if (window.innerWidth > 900) {
        if (foot && motionToggle.parentNode !== foot) {
          var cta = foot.querySelector('[data-rp-stl-open]');
          if (cta) foot.insertBefore(motionToggle, cta); else foot.appendChild(motionToggle);
        }
      } else if (heading && heading.parentNode && motionToggle.previousElementSibling !== heading) {
        heading.parentNode.insertBefore(motionToggle, heading.nextSibling);
      }
    }
    /* Desktop only: match the CTA — same height, each button half its width. Mobile
       clears the inline sizing (the segmented control is sized by CSS). */
    function updateMotionLayout() {
      if (!motionToggle) return;
      var btns = motionToggle.querySelectorAll('.rp-motion-btn');
      var cta = stlSec ? stlSec.querySelector('[data-rp-stl-open]') : null;
      if (window.innerWidth > 900 && cta && !cta.classList.contains('rp-hidden') && cta.offsetWidth) {
        var h = cta.offsetHeight, w = Math.round(cta.offsetWidth / 2);
        btns.forEach(function (b) { b.style.height = h + 'px'; b.style.width = w + 'px'; });
      } else {
        btns.forEach(function (b) { b.style.height = ''; b.style.width = ''; });
      }
    }
    /* Switching mode is SEAMLESS: both the Static portraits and the Motion video are
       built into the DOM once (renderStl) and we only flip which one is shown — no
       innerHTML rebuild, so nothing reloads or flashes. The active view is always reset
       to its first item (Static must show the first photo, never the last). */
    function applyStlMode() {
      if (!stlSec) return;
      var mediaEl = stlSec.querySelector('[data-rp-stl-media]');
      if (!mediaEl) return;
      var g = stlState.gender === 'w' ? 'w' : 'm';
      var hasMotion = !!mediaEl.querySelector('[data-rp-stl-grid="motion-' + g + '"]');
      var inMotion = stlState.mode === 'motion' && hasMotion;
      mediaEl.classList.toggle('is-motion', inMotion);
      var key = (inMotion ? 'motion-' : 'static-') + g;
      var activeGrid = null;
      mediaEl.querySelectorAll('[data-rp-stl-grid]').forEach(function (gr) {
        var on = gr.getAttribute('data-rp-stl-grid') === key;
        gr.classList.toggle('is-active', on);
        if (on) activeGrid = gr;
      });
      var modelEl = stlSec.querySelector('[data-rp-stl-model]');
      if (modelEl) {
        var cc = data.colors[state.color] || {};
        modelEl.textContent = (g === 'w' && cc.modelW) ? cc.modelW : (cc.model || '');
      }
      if (activeGrid) {
        activeGrid.style.overflowAnchor = 'none';   // don't let lazy-image reflow re-anchor the scroll onto slide 2
        var _stlReset = function () { activeGrid.scrollLeft = 0; };   // always start on the first item
        _stlReset();
        requestAnimationFrame(function () { _stlReset(); requestAnimationFrame(_stlReset); });
        // Mobile: STL slides are variable-height with lazy images. Before the first
        // image loads its slide is ~0 tall, so once it loads the browser's scroll
        // anchoring shifts the scroll onto slide 2. Re-pin to the first slide once
        // each media element has settled.
        activeGrid.querySelectorAll('img, video').forEach(function (el) {
          if (el.tagName === 'IMG') { if (!el.complete) el.addEventListener('load', _stlReset, { once: true }); }
          else { el.addEventListener('loadeddata', _stlReset, { once: true }); }
        });
      }
      var prog = stlSec.querySelector('[data-rp-stl-progress]');
      if (prog) {
        var n = activeGrid ? activeGrid.children.length : 0;
        var html = '';
        for (var i = 0; i < n; i++) { html += '<span class="rp-progress__bar' + (i === 0 ? ' is-active' : '') + '"></span>'; }
        prog.innerHTML = html;
        prog.classList.toggle('rp-hidden', n < 2);
        var bars = prog.querySelectorAll('.rp-progress__bar');
        bars.forEach(function (b, i) {
          b.style.cursor = 'pointer';
          b.addEventListener('click', function () {
            var mm = slideMetrics(activeGrid);
            activeGrid.scrollTo({ left: Math.max(0, i) * mm.step, behavior: 'smooth' });
          });
        });
        if (activeGrid) activeGrid.onscroll = function () {
          window.requestAnimationFrame(function () {
            var mm = slideMetrics(activeGrid); var idx = mm.step ? Math.round(activeGrid.scrollLeft / mm.step) : 0;
            bars.forEach(function (b, k) { b.classList.toggle('is-active', k === idx); });
          });
        };
      }
      updateMotionButtons();
      updateGenderButtons();
    }
    if (genderToggle) {
      genderToggle.querySelectorAll('[data-rp-gender]').forEach(function (b) {
        b.addEventListener('click', function () {
          var g = b.getAttribute('data-rp-gender');
          if (g === stlState.gender) return;
          stlState.gender = g;
          applyStlMode();
          updateStlCta(state.color);
          renderOutfit(state.color);
          renderDrawer(state.color);
          updateMotionLayout();
          track('running_look_gender', { gender: g });
        });
      });
    }
    if (motionToggle) {
      motionToggle.querySelectorAll('[data-rp-motion]').forEach(function (b) {
        b.addEventListener('click', function () {
          var mode = b.getAttribute('data-rp-motion');
          if (mode === stlState.mode) return;
          stlState.mode = mode;
          applyStlMode();                    // instant flip, no media rebuild
          track('running_media_mode', { mode: mode });
        });
      });
    }
    function updateSwatches() {
      swatches.forEach(function (s) {
        var on = s.getAttribute('data-rp-swatch') === state.color;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var activeGroup = ((data.colors[state.color] && data.colors[state.color].group) || '').toLowerCase();
      colorLabels.forEach(function (l) {
        var g = (l.getAttribute('data-rp-group') || '').toLowerCase();
        l.textContent = (g === '' || g === activeGroup) ? ('– ' + state.color) : '';
      });
    }
    function updateSizes() {
      sizeBtns.forEach(function (b) {
        var size = b.getAttribute('data-rp-size');
        var v = findVariant(state.color, size);
        var available = !!(v && v.available);
        b.classList.toggle('is-soldout', !available);
        b.classList.toggle('is-active', size === state.size);
        b.setAttribute('aria-pressed', size === state.size ? 'true' : 'false');
        var env = b.querySelector('.rp-size__env');
        if (env) env.classList.toggle('rp-hidden', available);
      });
    }
    function updateCart() {
      var v = findVariant(state.color, state.size);
      if (priceEl) priceEl.textContent = v ? v.priceFormatted : '';
      if (compareEl) {
        if (v && v.compareFormatted) { compareEl.textContent = v.compareFormatted; compareEl.classList.remove('rp-hidden'); priceEl.classList.add('running-pdp__price--sale'); }
        else { compareEl.classList.add('rp-hidden'); priceEl.classList.remove('running-pdp__price--sale'); }
      }
      var available = !!(v && v.available);
      var isPre = isPreorderVariant(v);
      if (atcBtn) atcBtn.textContent = atcLabelFor(v);
      if (atcBtn) atcBtn.classList.toggle('rp-hidden', !available);
      if (notifyBtn) notifyBtn.classList.toggle('rp-hidden', available);
      if (v && nativeSelect) { nativeSelect.value = v.id; try { nativeSelect.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {} }
      if (v) {
        try { window.history.replaceState({ variant: v.id }, '', data.productUrl + '?variant=' + v.id); } catch (e) {}
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: { id: v.id, available: v.available, preorder: isPre }, shipLabel: data.shipLabel || null } }));
      }
      if (typeof updateStickyBar === 'function') updateStickyBar();
    }

    /* ---------- add to cart (AJAX, reuse theme drawer if present) ----------
       silent = true: only refresh the theme cart (contents + bubble) WITHOUT opening
       the cart drawer. Impulse's CartDrawer opens on 'ajaxProduct:added', while
       'cart:build' just rebuilds its contents – that is what the Shop-the-Look
       drawer uses so the customer stays in the look. */
    function addToCart(variantId, btn, done, silent, props) {
      var label = btn ? btn.textContent : '';
      if (silent) suppressThemeCartDrawer(2500);
      var payload = { id: variantId, quantity: 1 };
      if (props) payload.properties = props;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = label; }, 1600); }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent(silent ? 'cart:build' : 'ajaxProduct:added'));
          // best-effort: refresh theme cart bubble
          var bubble = document.querySelector('[data-cart-count], .cart-link__bubble');
          if (bubble) { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { bubble.textContent = c.item_count; }); }
          if (done) done(true);
        })
        .catch(function () {
          if (btn) { btn.textContent = 'Error'; setTimeout(function () { btn.textContent = label; }, 1600); }
          if (done) done(false);
        });
    }

    /* Read the real cart so the green "already in the cart" state survives closing the
       drawer, a page change, or the customer removing the line again elsewhere. */
    function syncCartState() {
      if (!drawerBody) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          addedIds = {};
          (c.items || []).forEach(function (li) { addedIds[String(li.id)] = true; });
          drawerBody.querySelectorAll('[data-rp-ditem-row]').forEach(syncAddBtn);
        })
        .catch(function () {});
    }

    /* Look-Produkte sind primaer PRO FARBE hinterlegt (Farb-Metaobjekt -> look_products).
       Hat eine Farbe nichts eigenes, greift die produktweite Liste. So kann pro Farbvariante
       ein eigenes Outfit stehen, ohne dass ein Produkt ohne Pflege leer ausgeht. */
    function lookItemsFor(color) {
      var c = data.colors[color] || {};
      // A configured women list can be empty when its products are not published.
      // In that case never substitute the men's outfit. null keeps legacy fallback.
      if (stlState.gender === 'w' && Array.isArray(c.lookItemsW)) return c.lookItemsW;
      if (c.lookItems && c.lookItems.length) return c.lookItems;
      return data.lookItems || [];
    }

    function updateStlCta(color) {
      var cta = stlSec ? stlSec.querySelector('[data-rp-stl-open]') : null;
      if (cta) cta.classList.toggle('rp-hidden', !lookItemsFor(color).length);
    }

    /* ---------- Shop the Look (Static portraits / Motion video) ---------- */
    /* Builds BOTH the Static portrait view and the Motion video view into the media
       container up front. Switching between them is then just a class flip in
       applyStlMode() — instant, no reload, no flash. */
    function renderStl(color) {
      if (!stlSec) return;
      var c = data.colors[color] || {};
      var women = hasWomen(color);
      if (!women) stlState.gender = 'm';
      if (genderToggle) genderToggle.classList.toggle('rp-hidden', !women);
      var look = lookList(color, 'm');
      var motion = motionList(color, 'm');
      var lookW = women ? lookList(color, 'w') : [];
      var motionW = women ? motionList(color, 'w') : [];
      var hasMotion = motion.length > 0 || motionW.length > 0;

      // the toggle only exists while this colour has a Motion video
      if (!hasMotion && stlState.mode === 'motion') stlState.mode = 'static';
      if (motionToggle) motionToggle.classList.toggle('rp-hidden', !hasMotion);
      updateMotionButtons();

      if (!look.length && !hasMotion) { stlSec.classList.add('rp-hidden'); return; }
      stlSec.classList.remove('rp-hidden');

      function itemsHtml(arr) {
        return arr.map(function (m) {
          if (m.type === 'video') {
            var cand = videoCandidates(m);
            return '<div class="rp-stl__item rp-stl__item--video" data-rp-stl-click><video data-rp-video data-rp-src="' + esc(cand[0] || '') + '" data-rp-alt="' + esc(cand.slice(1).join('|')) + '" muted loop playsinline webkit-playsinline autoplay preload="none" ' + (m.poster ? 'poster="' + esc(m.poster) + '"' : '') + '></video></div>';
          }
          return '<div class="rp-stl__item" data-rp-stl-click><img loading="lazy" src="' + esc(m.src) + '" alt="' + esc(data.title + ' – ' + color) + '"></div>';
        }).join('');
      }

      var mediaEl = stlSec.querySelector('[data-rp-stl-media]');
      mediaEl.innerHTML =
        '<div class="rp-stl__grid rp-stl__grid--static" data-rp-stl-grid="static-m">' + itemsHtml(look) + '</div>' +
        (motion.length ? '<div class="rp-stl__grid rp-stl__grid--motion" data-rp-stl-grid="motion-m">' + itemsHtml(motion) + '</div>' : '') +
        (women ? '<div class="rp-stl__grid rp-stl__grid--static" data-rp-stl-grid="static-w">' + itemsHtml(lookW) + '</div>' : '') +
        (women && motionW.length ? '<div class="rp-stl__grid rp-stl__grid--motion" data-rp-stl-grid="motion-w">' + itemsHtml(motionW) + '</div>' : '');

      var modelEl = stlSec.querySelector('[data-rp-stl-model]');
      if (modelEl) { modelEl.textContent = c.model || ''; }
      updateStlCta(color);

      mediaEl.querySelectorAll('[data-rp-stl-click]').forEach(function (el) {
        el.addEventListener('click', function () { if (lookItemsFor(state.color).length) openDrawer(); });
      });
      observeVideos(mediaEl);

      placeMotionToggle();
      placeGenderToggle();
      applyStlMode();
      updateMotionLayout();
    }

    /* ---------- Details slider ---------- */
    function renderDetails(color) {
      if (!detailsSec) return;
      var c = data.colors[color] || {};
      var det = c.details || [];
      if (!det.length) { detailsSec.classList.add('rp-hidden'); return; }
      detailsSec.classList.remove('rp-hidden');
      var slider = detailsSec.querySelector('[data-rp-details-slider]');
      slider.innerHTML =
        '<button type="button" class="rp-slider__arrow rp-slider__arrow--prev" data-rp-prev aria-label="Previous image"><svg viewBox="0 0 24 24" fill="none"><path d="M15 4l-8 8 8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<button type="button" class="rp-slider__arrow rp-slider__arrow--next" data-rp-next aria-label="Next image"><svg viewBox="0 0 24 24" fill="none"><path d="M9 4l8 8-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<div class="rp-slider__track rp-details__track" data-rp-track>' +
          det.map(function (src, i) { return '<div class="rp-details__slide"><div class="rp-details__sq"><img loading="' + (i < 2 ? 'eager' : 'lazy') + '" src="' + esc(src) + '" alt="' + esc(data.title + ' – detail ' + (i + 1)) + '"></div></div>'; }).join('') +
        '</div>' +
        '<div class="rp-progress">' + det.map(function (_, i) { return '<span class="rp-progress__bar' + (i === 0 ? ' is-active' : '') + '"></span>'; }).join('') + '</div>';
      bindSlider(slider);
    }

    /* ---------- More Colors and Styles ---------- */
    function renderMore() {
      if (!moreTrack) return;
      // never show the current colour again; hide the whole block if nothing is left
      var keys = Object.keys(data.colors).filter(function (color) { return color !== state.color; });
      if (!keys.length) {
        moreTrack.innerHTML = '';
        if (moreSec) moreSec.classList.add('rp-hidden');
        return;
      }
      if (moreSec) moreSec.classList.remove('rp-hidden');
      moreTrack.innerHTML = keys.map(function (color) {
        var c = data.colors[color];
        var img = c.card || c.front || '';
        return '<a class="rp-card" href="#" data-rp-more="' + esc(color) + '">' +
          '<div class="rp-card__img">' + (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(data.title + ' – ' + color) + '">' : '') + '</div>' +
          '<div class="rp-card__meta"><span class="rp-card__name">' + esc(data.title) + '</span><span class="rp-card__sub">' + esc(color) + '</span><span class="rp-card__price">' + esc(data.productPrice) + '</span></div>' +
        '</a>';
      }).join('');
      moreTrack.querySelectorAll('[data-rp-more]').forEach(function (el) {
        el.addEventListener('click', function (ev) {
          ev.preventDefault();
          selectColor(el.getAttribute('data-rp-more'));
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    /* ---------- Create Your Outfit ---------- */
    function renderOutfit(color) {
      if (!outfitSec) return;
      var items = lookItemsFor(color);
      // dedupe by url
      var seen = {}, uniq = [];
      items.forEach(function (it) { if (!seen[it.url]) { seen[it.url] = 1; uniq.push(it); } });
      if (!uniq.length) { outfitSec.classList.add('rp-hidden'); return; }
      outfitSec.classList.remove('rp-hidden');
      var track = outfitSec.querySelector('[data-rp-outfit-track]');
      track.innerHTML = uniq.map(function (it) {
        var price = (it.sizes && it.sizes[0] && it.sizes[0].price) || '';
        return '<a class="rp-card" href="' + esc(it.url) + '">' +
          '<div class="rp-card__img">' + (it.image ? '<img loading="lazy" src="' + esc(it.image) + '" alt="' + esc(it.title) + '">' : '') + '</div>' +
          '<div class="rp-card__meta"><span class="rp-card__name">' + esc(it.title) + '</span><span class="rp-card__sub">' + esc(it.color) + '</span><span class="rp-card__price">' + esc(price) + '</span></div>' +
        '</a>';
      }).join('');
    }

    /* ---------- Drawer ---------- */
    /* The colour is dictated by the look, so each row only needs a size choice and a
       buy button — identical markup/classes to the main PDP buy box (.rp-sizes/.rp-size
       /.rp-btn) so it reads as the same control. Once a row is in the cart its button
       stays green with a check; it is not a 2-second flash, the customer has to be able
       to see at a glance which pieces of the look they already took. */
    var drawerState = {};
    var addedIds = {};
    function markAdded(btn, on, v, item) {
      if (!btn) return;
      btn.classList.toggle('is-added', !!on);
      if (!on && !v) {
        var mRow = btn.closest ? btn.closest('[data-rp-ditem-row]') : null;
        var mSizeBtn = mRow ? mRow.querySelector('.rp-size.is-active') : null;
        var mDid = mSizeBtn ? mSizeBtn.getAttribute('data-rp-did') : null;
        if (mDid) {
          (lookItemsFor(state.color) || []).forEach(function (it) {
            (((it && it.sizes) || [])).forEach(function (s) { if (String(s.id) === String(mDid)) { v = s; item = it; } });
          });
        }
      }
      btn.innerHTML = on
        ? '<svg class="rp-btn__check" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12.5l5.2 5.2L20 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(labels.added || 'Added')
        : esc(lookLabelFor(item, v));
    }
    function syncAddBtn(row) {
      if (!row) return;
      var sizeBtn = row.querySelector('.rp-size.is-active');
      var add = row.querySelector('[data-rp-dadd]');
      if (!sizeBtn || !add) return;
      markAdded(add, !!addedIds[sizeBtn.getAttribute('data-rp-did')]);
    }
    function renderDrawer(color) {
      if (!drawerBody) return;
      var items = lookItemsFor(color);
      drawerState = {};
      drawerBody.innerHTML = items.map(function (it, idx) {
        var sizes = it.sizes || [];
        var firstAvail = sizes.filter(function (s) { return s.available; })[0] || sizes[0] || {};
        drawerState[idx] = firstAvail.size;
        var price = firstAvail.price || (sizes[0] && sizes[0].price) || '';
        var sizeBtns = sizes.map(function (s) {
          return '<button type="button" class="rp-size' + (s.available ? '' : ' is-soldout') + (s.size === firstAvail.size ? ' is-active' : '') + '" data-rp-ditem="' + idx + '" data-rp-dsize="' + esc(s.size) + '" data-rp-did="' + s.id + '" data-rp-davail="' + s.available + '" aria-pressed="' + (s.size === firstAvail.size ? 'true' : 'false') + '">' +
            '<span>' + esc(s.size) + '</span>' +
            '<svg class="rp-size__env' + (s.available ? ' rp-hidden' : '') + '" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="6" width="18" height="12" rx="1" stroke="currentColor" stroke-width="1.4"/><path d="M4 7l8 6 8-6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
          '</button>';
        }).join('');
        var canCart = !!firstAvail.available;
        return '<div class="rp-ditem" data-rp-ditem-row="' + idx + '">' +
          '<div class="rp-ditem__top">' +
            '<a class="rp-ditem__img" href="' + esc(it.url) + '">' + (it.image ? '<img loading="lazy" src="' + esc(it.image) + '" alt="' + esc(it.title) + '">' : '') + '</a>' +
            '<div class="rp-ditem__info">' +
              '<a class="rp-ditem__name" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
              '<div class="rp-ditem__sub">' + esc(it.color) + '</div>' +
              '<div class="rp-ditem__price">' + esc(price) + '</div>' +
            '</div>' +
          '</div>' +
          (sizes.length ? '<div class="rp-ditem__buy">' +
            '<div class="rp-sizes rp-dsizes">' + sizeBtns + '</div>' +
            '<button type="button" class="rp-btn rp-dbtn' + (canCart ? '' : ' rp-hidden') + '" data-rp-dadd="' + idx + '">' + esc(lookLabelFor(it, firstAvail)) + '</button>' +
            '<button type="button" class="rp-btn rp-dbtn--notify' + (canCart ? ' rp-hidden' : '') + '" data-rp-dnotify="' + idx + '">' + esc(labels.notify) + '</button>' +
          '</div>' : '') +
        '</div>';
      }).join('');

      drawerBody.querySelectorAll('[data-rp-dsize]').forEach(function (b) {
        b.addEventListener('click', function () {
          var i = b.getAttribute('data-rp-ditem');
          drawerState[i] = b.getAttribute('data-rp-dsize');
          drawerBody.querySelectorAll('[data-rp-ditem="' + i + '"]').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
          var avail = b.getAttribute('data-rp-davail') === 'true';
          var row = drawerBody.querySelector('[data-rp-ditem-row="' + i + '"]');
          var addBtn = row.querySelector('[data-rp-dadd]');
          addBtn.classList.toggle('rp-hidden', !avail);
          row.querySelector('[data-rp-dnotify]').classList.toggle('rp-hidden', avail);
          var newSize = (((items[i] && items[i].sizes) || []).filter(function (s) { return String(s.id) === String(b.getAttribute('data-rp-did')); })[0]) || null;
          if (!addBtn.classList.contains('is-added')) addBtn.innerHTML = esc(lookLabelFor(items[i], newSize));
          syncAddBtn(row); // the green state belongs to the variant, not the row
        });
      });
      drawerBody.querySelectorAll('[data-rp-dadd]').forEach(function (b) {
        b.addEventListener('click', function () {
          var i = b.getAttribute('data-rp-dadd');
          var sizeBtn = drawerBody.querySelector('[data-rp-ditem="' + i + '"].is-active');
          if (!sizeBtn) return;
          var vid = sizeBtn.getAttribute('data-rp-did');
          var dItem = items[i];
          var dSize = (((dItem && dItem.sizes) || []).filter(function (s) { return String(s.id) === String(vid); })[0]) || null;
          addToCart(parseInt(vid, 10), null, function (ok) {
            if (!ok) { b.classList.add('is-error'); setTimeout(function () { b.classList.remove('is-error'); }, 1600); return; }
            addedIds[vid] = true;
            markAdded(b, true);
          }, true, lookPropsFor(dItem, dSize));
        });
      });
      /* The Notify-Me app can only ever render its subscription widget for the product
         of the CURRENT page (single, once-only mount) – there is no public API to open
         it for a foreign product. So the drawer hands over to that product's PDP with
         the exact variant preselected (?variant=) and the #rp-notify marker, which the
         running PDP picks up on load and opens the popup immediately. */
      drawerBody.querySelectorAll('[data-rp-dnotify]').forEach(function (b) {
        b.addEventListener('click', function () {
          var i = b.getAttribute('data-rp-dnotify');
          var it = items[i];
          if (!it || !it.url) return;
          var sizeBtn = drawerBody.querySelector('[data-rp-ditem="' + i + '"].is-active');
          var vid = sizeBtn ? sizeBtn.getAttribute('data-rp-did') : '';
          track('running_notify_me_opened', { source: 'shop_the_look' });
          var base = it.url.split('#')[0];
          var sep = base.indexOf('?') === -1 ? '?' : '&';
          window.location.href = base + (vid ? sep + 'variant=' + vid : '') + '#rp-notify';
        });
      });
      // a row may already be in the cart from an earlier open of the drawer
      drawerBody.querySelectorAll('[data-rp-ditem-row]').forEach(syncAddBtn);
    }

    var lastFocus = null;
    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var f = drawer.querySelector('.rp-drawer__close');
      if (f) f.focus();
      document.addEventListener('keydown', onKey);
      syncCartState();
      track('running_shop_the_look_opened', {});
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key === 'Tab') {
        var f = drawer.querySelectorAll('button, a, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    if (drawer) {
      drawer.querySelectorAll('[data-rp-drawer-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
    }
    var stlOpenBtn = root.querySelector('[data-rp-stl-open]');
    if (stlOpenBtn) stlOpenBtn.addEventListener('click', openDrawer);

    /* Modelzeile in der Kaufspalte. Kommt aus dem Farb-Metaobjekt (Model aus Bibliothek)
       und wird bei jedem Farbwechsel neu gesetzt; ohne Model bleibt die Zeile aus. */
    function renderModelNote(color) {
      var el = root.querySelector('[data-rp-model-note]');
      if (!el) return;
      var txt = (data.colors[color] || {}).model || '';
      el.textContent = txt;
      el.classList.toggle('rp-hidden', !txt);
    }

    function renderColorSections(color) {
      renderMockups(color);
      renderModelNote(color);
      renderStl(color);
      renderDetails(color);
      renderOutfit(color);
      renderDrawer(color);
      renderMore();
    }

    /* ---------- selection ---------- */
    /* Der schwarze Ring muss im selben Frame wie der Klick an der neuen Farbe sitzen.
       Vorher lief renderColorSections() synchron im Klick-Task und baute per innerHTML
       Mockups, Shop the Look, Details, Outfit, Drawer und "Weitere Farben" neu auf
       (live gemessen ~130-220 ms). So lange kam der Browser nicht zum Zeichnen: die
       Umrandung blieb sichtbar an der ALTEN Farbe stehen und sprang erst danach --
       zwischen Seasonal- und Core-Block faellt das besonders auf, weil die beiden
       Reihen untereinander liegen und der Ring dabei eine Zeile weit springt.
       Jetzt zuerst die billigen Zustandsupdates (Swatches/Groessen/Preis), dann ein
       Frame zum Zeichnen, erst danach der schwere Neuaufbau. Der Token verwirft
       veraltete Laeufe, wenn schnell hintereinander mehrere Farben geklickt werden. */
    var colorRenderToken = 0;
    function selectColor(color) {
      if (!data.colors[color]) return;
      state.color = color;
      var v = findVariant(color, state.size);
      if (!v || !v.available) { state.size = firstAvailableSize(color); }
      updateSwatches(); updateSizes(); updateCart();
      var token = ++colorRenderToken;
      var run = function () { if (token === colorRenderToken) renderColorSections(color); };
      if (typeof window.requestAnimationFrame === 'function') {
        /* doppeltes rAF: der zweite Callback laeuft erst nach dem Paint des ersten */
        window.requestAnimationFrame(function () { window.requestAnimationFrame(run); });
      } else {
        setTimeout(run, 0);
      }
      track('running_color_selected', { color: color });
    }
    function selectSize(size) { state.size = size; updateSizes(); updateCart(); track('running_size_selected', { size: size }); }

    function track(name, extra) {
      var v = findVariant(state.color, state.size);
      var payload = Object.assign({ product_id: data.productId, variant_id: v ? v.id : null, style: data.title, color: state.color, size: state.size, technology: data.technology || null }, extra || {});
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, payload)); } catch (e) {}
    }

    swatches.forEach(function (s) { s.addEventListener('click', function () { selectColor(s.getAttribute('data-rp-swatch')); }); });
    sizeBtns.forEach(function (b) { b.addEventListener('click', function () { selectSize(b.getAttribute('data-rp-size')); }); });

    /* ---------- Haupt-Warenkorbbutton ----------
       Frueher haben wir hier den echten Theme-Button im versteckten Formular geklickt
       (realAtc.click()). Das war falsch: Impulse haengt sein AJAX nur an die Formulare
       der eigenen Produktsektion, unser Formular kennt es nicht. Der Klick loeste also
       einen ganz normalen Form-Submit auf /cart/add aus – kompletter Seitenwechsel,
       kein Drawer. Jetzt legen wir selbst per /cart/add.js an (silent = false), damit
       'ajaxProduct:added' feuert und Impulse den Warenkorb-Drawer oeffnet.
       Wichtig: die Drawer-Sperre aus Shop the Look laeuft 2,5 s nach. Klickt der Kunde
       direkt danach hier, waere der Drawer noch blockiert – deshalb heben wir die Sperre
       fuer diesen Klick gezielt auf. In Shop the Look selbst bleibt sie unveraendert. */
    function releaseCartDrawerBlock() {
      rpBlockUntil = 0;
      clearTimeout(rpBlockTimer);
      document.documentElement.classList.remove('rp-cartdrawer-off');
    }

    function mainAddToCart(btn) {
      var v = findVariant(state.color, state.size);
      if (!v || !v.available) return;
      if (btn && btn.disabled) return;
      if (nativeSelect) { nativeSelect.value = v.id; try { nativeSelect.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {} }
      track('running_add_to_cart', {});
      releaseCartDrawerBlock();
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      addToCart(v.id, null, function (ok) {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        if (ok) closeStickyPanel();
      }, false, preorderProps(v));
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function () { mainAddToCart(atcBtn); });
    }
    /* Opens the Notify-Me app popup for the given variant. The app injects its own
       button into the hidden theme form; we preselect the variant first so the
       subscription is stored for the right size. When we arrive from Shop the Look the
       app SDK may still be booting, hence the short poll (max ~10 s). */
    function openNotifyPopup(v, retry) {
      if (v && nativeSelect) { nativeSelect.value = v.id; try { nativeSelect.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {} }
      var tries = 0;
      (function poll() {
        var appBtn = (formHolder && formHolder.querySelector('.restock-alerts-notify-button')) || document.querySelector('.restock-alerts-notify-button');
        if (appBtn) { appBtn.click(); return; }
        if (typeof window.__runningNotify === 'function') { window.__runningNotify(v ? v.id : null); return; }
        if (retry && ++tries < 40) setTimeout(poll, 250);
      })();
    }
    if (notifyBtn) {
      notifyBtn.addEventListener('click', function () {
        track('running_notify_me_opened', {});
        openNotifyPopup(findVariant(state.color, state.size), false);
      });
    }

    // initial paint
    updateSwatches(); updateSizes(); updateCart();
    renderMore();
    renderColorSections(state.color);

    /* Arrived from a Shop-the-Look "Benachrichtigen" click: open the popup right away.
       ?variant= has already put us on the right colour/size (Liquid:
       selected_or_first_available_variant), so we only need to fire the popup. */
    if (/(^|[#&])rp-notify\b/.test(window.location.hash || '')) {
      try { window.history.replaceState({}, '', window.location.pathname + window.location.search); } catch (e) {}
      openNotifyPopup(findVariant(state.color, state.size), true);
    }

    /* ---------- Temperature unit toggle (°C / °F) ---------- */
    var tempEl = root.querySelector('[data-rp-temp]');
    if (tempEl) {
      var unitBtns = tempEl.querySelectorAll('[data-rp-temp-unit]');
      var tempLabels = tempEl.querySelectorAll('.rp-temp__label');
      unitBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var unit = b.getAttribute('data-rp-temp-unit');
          unitBtns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
          tempLabels.forEach(function (l) {
            var v = unit === 'f' ? l.getAttribute('data-f') : l.getAttribute('data-c');
            if (v) l.textContent = v;
          });
        });
      });
    }

    /* ---------- JS sticky for the buy column (stays until the outfit section) ---------- */
    var infoCol = root.querySelector('.running-pdp__right');
    var infoInner = root.querySelector('.running-pdp__info-inner');
    var stickyOffset = 100;
    var mstop = /(-?\d+)/.exec(root.style.getPropertyValue('--rp-sticky-top') || '');
    if (mstop) stickyOffset = parseInt(mstop[1], 10) || 100;
    var lastScrollY = window.pageYOffset;
    var curTop = stickyOffset; // desired viewport-top while pinned (used for tall-content follow)
    function clearSticky() {
      infoInner.classList.remove('is-fixed', 'is-bottom', 'is-abstop');
      infoInner.style.top = ''; infoInner.style.bottom = ''; infoInner.style.left = ''; infoInner.style.width = '';
    }
    function setFixed(topPx, leftPx, w) {
      infoInner.classList.add('is-fixed'); infoInner.classList.remove('is-bottom', 'is-abstop');
      infoInner.style.bottom = ''; infoInner.style.top = topPx + 'px'; infoInner.style.left = leftPx + 'px'; infoInner.style.width = w + 'px';
    }
    function setBottom(w) {
      infoInner.classList.add('is-bottom'); infoInner.classList.remove('is-fixed', 'is-abstop');
      infoInner.style.top = ''; infoInner.style.bottom = '0'; infoInner.style.left = '0'; infoInner.style.width = w + 'px';
    }
    function setAbsTop(w) {
      infoInner.classList.add('is-abstop'); infoInner.classList.remove('is-fixed', 'is-bottom');
      infoInner.style.bottom = ''; infoInner.style.top = '0'; infoInner.style.left = '0'; infoInner.style.width = w + 'px';
    }
    function updateSticky() {
      if (!infoCol || !infoInner) return;
      if (window.innerWidth <= 900 || infoInner.parentNode !== infoCol) { clearSticky(); lastScrollY = window.pageYOffset; return; }
      var colRect = infoCol.getBoundingClientRect();
      var innerH = infoInner.offsetHeight;
      var colH = infoCol.offsetHeight;
      var vh = window.innerHeight;
      var w = infoCol.clientWidth;
      var y = window.pageYOffset;
      var dy = y - lastScrollY;
      lastScrollY = y;

      // haven't scrolled into the sticky zone yet, or the column can't scroll past the box
      if (colRect.top >= stickyOffset || colH <= innerH + 1) { clearSticky(); curTop = stickyOffset; return; }

      var fits = innerH <= vh - stickyOffset;           // short enough to simply pin at the top
      var desiredTop;
      if (fits) {
        desiredTop = stickyOffset;
      } else {
        // TALL content (e.g. long Details text open): follow the scroll direction so the
        // whole box is reachable — scroll down reveals the bottom, scroll up the top.
        // Never un-stick, never jump.
        var minTop = vh - innerH;                       // bottom flush with viewport bottom
        desiredTop = curTop - dy;
        if (desiredTop > stickyOffset) desiredTop = stickyOffset;
        if (desiredTop < minTop) desiredTop = minTop;
        curTop = desiredTop;
      }

      var relTop = desiredTop - colRect.top;             // where that maps inside the column
      var maxRel = colH - innerH;                        // element's lowest top within the column
      if (relTop <= 0) {
        setAbsTop(w); curTop = colRect.top;              // ride the column top; resync to avoid a jump
      } else if (relTop >= maxRel) {
        setBottom(w); curTop = colRect.top + maxRel;     // ride the column bottom; resync
      } else {
        setFixed(desiredTop, colRect.left, w);
      }
    }

    /* ---------- Mobile sticky add-to-cart bar (Satisfy-Prinzip) ----------
       Eingeklappt: Name + Preis + Button. Erster Tipp auf den Button klappt das
       Groessenpanel auf, erst der zweite legt in den Warenkorb. Ist die Groesse
       ausverkauft, oeffnet der Button direkt das Notify-Popup. */
    var stickyBar = root.querySelector('[data-rp-stickybar]');
    var stickyBarBtn = root.querySelector('[data-rp-stickybar-btn]');
    var stickyBarPrice = root.querySelector('[data-rp-stickybar-price]');
    var stickyPanel = root.querySelector('[data-rp-stickybar-panel]');

    function stickyPanelIsOpen() { return !!(stickyBar && stickyBar.classList.contains('is-expanded')); }
    function openStickyPanel() {
      if (!stickyBar || !stickyPanel || stickyPanelIsOpen()) return;
      stickyPanel.hidden = false;
      stickyBar.classList.add('is-expanded');
    }
    function closeStickyPanel() {
      if (!stickyBar || !stickyPanel || !stickyPanelIsOpen()) return;
      stickyBar.classList.remove('is-expanded');
      stickyPanel.hidden = true;
    }

    function updateStickyBar() {
      if (!stickyBar) return;
      var v = findVariant(state.color, state.size);
      if (stickyBarPrice) stickyBarPrice.textContent = v ? v.priceFormatted : '';
      if (stickyBarBtn) stickyBarBtn.textContent = (v && v.available) ? atcLabelFor(v) : labels.notify;
    }
    if (stickyBarBtn) {
      stickyBarBtn.addEventListener('click', function () {
        var v = findVariant(state.color, state.size);
        if (!v || !v.available) { closeStickyPanel(); if (notifyBtn) notifyBtn.click(); return; }
        // Erster Tipp: aufklappen und den Kunden die Groesse bestaetigen lassen.
        if (stickyPanel && !stickyPanelIsOpen()) { openStickyPanel(); return; }
        mainAddToCart(stickyBarBtn);
      });
    }
    // Tipp ausserhalb der Bar schliesst das Panel wieder.
    document.addEventListener('click', function (e) {
      if (!stickyPanelIsOpen()) return;
      if (stickyBar && stickyBar.contains(e.target)) return;
      closeStickyPanel();
    }, true);

    function updateStickyBarVisibility() {
      if (!stickyBar) return;
      if (window.innerWidth > 900) { closeStickyPanel(); stickyBar.classList.remove('is-visible'); stickyBar.setAttribute('aria-hidden', 'true'); return; }
      var trigger = (stlSec && !stlSec.classList.contains('rp-hidden')) ? stlSec
                  : ((detailsSec && !detailsSec.classList.contains('rp-hidden')) ? detailsSec : null);
      if (!trigger) { stickyBar.classList.remove('is-visible'); return; }
      /* Die Bar soll erscheinen, sobald der Kunde die Haelfte von Shop the Look
         erreicht – also sobald die Mitte der Sektion von unten ins Bild kommt.
         Vorher lag die Schwelle bei 55 % der Viewporthoehe, damit kam die Bar
         rund eine Bildschirmhoehe zu spaet. */
      var r = trigger.getBoundingClientRect();
      var mid = r.top + r.height / 2;
      var show = mid <= window.innerHeight;
      if (!show) closeStickyPanel();
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    updateStickyBar();

    var scrollTick = false;
    function onScrollFrame() {
      if (scrollTick) return; scrollTick = true;
      window.requestAnimationFrame(function () { updateSticky(); updateStickyBarVisibility(); scrollTick = false; });
    }
    window.addEventListener('scroll', onScrollFrame, { passive: true });
    window.addEventListener('resize', onScrollFrame);
    window.addEventListener('load', function () { updateSticky(); updateStickyBarVisibility(); });
    // recompute sticky when accordions expand/collapse (height of the buy column changes)
    root.querySelectorAll('[data-rp-acc-head]').forEach(function (h) {
      h.addEventListener('click', function () { window.requestAnimationFrame(updateSticky); });
    });
    root.querySelectorAll('[data-rp-acc-body]').forEach(function (b) {
      b.addEventListener('transitionend', function (e) { if (e.propertyName === 'height') updateSticky(); });
    });

    /* ---------- Responsive reflow: mobile stacks media > info > STL > details > accordions > more ---------- */
    var mainEl = root.querySelector('.running-pdp__main');
    var leftEl = root.querySelector('.running-pdp__left');
    var rightEl = root.querySelector('.running-pdp__right');
    var mediaEl = root.querySelector('.running-pdp__media');
    var accEl = root.querySelector('.rp-accordions');
    var accHome = accEl ? { parent: accEl.parentNode, next: accEl.nextSibling } : null;
    var mq = window.matchMedia('(max-width: 900px)');
    function reflow() {
      if (mq.matches) {
        if (rightEl && leftEl && mediaEl && rightEl.parentNode !== leftEl) {
          leftEl.insertBefore(rightEl, mediaEl.nextSibling);
        }
        if (accEl && detailsSec && detailsSec.parentNode) {
          detailsSec.parentNode.insertBefore(accEl, detailsSec);
          accEl.classList.add('rp-accordions--detached');
        }
      } else {
        if (rightEl && mainEl && rightEl.parentNode !== mainEl) {
          mainEl.appendChild(rightEl);
        }
        if (accEl && accHome) {
          accHome.parent.insertBefore(accEl, accHome.next);
          accEl.classList.remove('rp-accordions--detached');
        }
      }
      updateMotionLayout();
      updateSticky();
      updateStickyBarVisibility();
    }
    reflow();
    /* Bug: after a desktop<->mobile switch the top gallery sometimes showed the 2nd
       (mobile) or last (desktop) image instead of the first, because the loop-slider
       preserved its scroll index across the big width change. On every breakpoint
       change we rebuild the top gallery at the first slide and re-fit the toggle. */
    function onBreakpointChange() {
      reflow();
      renderMockups(state.color);
      placeMotionToggle();
      placeGenderToggle();
      applyStlMode();
      updateMotionLayout();
    }
    if (mq.addEventListener) mq.addEventListener('change', onBreakpointChange); else if (mq.addListener) mq.addListener(onBreakpointChange);
  }

  function initSizeGuide(root) {
    root.querySelectorAll('[data-rp-sizeguide]').forEach(function (btn) {
      btn.addEventListener('click', function () { var open = document.querySelector('[data-fit-check-open]'); if (open) open.click(); });
    });
  }

  function boot() {
    document.querySelectorAll('[data-rp-root]').forEach(function (root) {
      initPDP(root);
      initAccordions(root);
      initSizeGuide(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

